import { Directive, ElementRef, HostListener, Input, NgModule  } from '@angular/core';

@Directive({
    selector: '[appNumericfield]',
    standalone: false
})
export class NumericfieldDirective {

  regexStr = '^[0-9]*$';
  constructor(private el: ElementRef) { }
  @Input() OnlyNumber: boolean;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent> event;

      if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
      }
      var myKeyCode = e.keyCode;
      if (myKeyCode >= 96 && myKeyCode <= 105) {
        // Numpad keys
        myKeyCode -= 48;
      }
      let ch = String.fromCharCode(myKeyCode);
      let regEx =  new RegExp(this.regexStr);    
      if(e.shiftKey === false && regEx.test(ch)){
        return;
      }
      else
        e.preventDefault();
  }

}

@NgModule({
  declarations: [ NumericfieldDirective ],
  exports: [ NumericfieldDirective ]
})
 
export class NumericfieldDirectiveModule {}